'use client';
import React, { useEffect } from 'react';

export default function WaitlistSection() {
  useEffect(() => {
    const w = 'https://tally.so/widgets/embed.js';
    const loadTally = () => {
      if (typeof (window as any).Tally !== 'undefined') {
        (window as any).Tally.loadEmbeds();
      } else {
        document
          .querySelectorAll<HTMLIFrameElement>('iframe[data-tally-src]:not([src])')
          .forEach((e) => {
            e.src = e.dataset.tallySrc || '';
          });
      }
    };

    if (typeof (window as any).Tally !== 'undefined') {
      loadTally();
    } else if (!document.querySelector(`script[src="${w}"]`)) {
      const s = document.createElement('script');
      s.src = w;
      s.onload = loadTally;
      s.onerror = loadTally;
      document.body.appendChild(s);
    } else {
      loadTally();
    }
  }, []);

  return (
    <section
      id="waitlist"
      className="mb-12 md:mb-16"
      style={{
        background: 'linear-gradient(135deg, #0d0d2b 0%, #111130 100%)',
        border: '1px solid rgba(0,245,255,0.2)',
        padding: 'clamp(32px, 5vw, 56px) clamp(20px, 4vw, 48px)',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 0 40px rgba(0,245,255,0.06)',
      }}
    >
      {/* Cyan accent stripe */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '3px',
          background: 'linear-gradient(90deg, #00f5ff, #7b2fff, #ff00ff)',
          boxShadow: '0 0 12px rgba(0,245,255,0.4)',
        }}
      />
      {/* Background glow */}
      <div
        style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(123,47,255,0.08) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      {/* Header */}
      <div className="mb-8">
        <div
          className="inline-block px-3 py-1 mb-3"
          style={{ background: 'rgba(0,245,255,0.08)', border: '1px solid rgba(0,245,255,0.3)' }}
        >
          <span
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 900,
              fontSize: '11px',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              color: '#00f5ff',
            }}
          >
            Early Access
          </span>
        </div>
        <h2
          style={{
            fontFamily: 'Barlow Condensed, Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(32px, 6vw, 56px)',
            textTransform: 'uppercase',
            color: '#e0e8ff',
            lineHeight: 0.95,
            letterSpacing: '0.01em',
            marginBottom: '8px',
            textShadow: '0 0 30px rgba(0,245,255,0.15)',
          }}
        >
          Join the Waitlist
        </h2>
        <p
          style={{
            fontFamily: 'Barlow Condensed, Arial, sans-serif',
            fontWeight: 700,
            fontSize: 'clamp(16px, 2.5vw, 22px)',
            textTransform: 'uppercase',
            color: '#00f5ff',
            letterSpacing: '0.04em',
            textShadow: '0 0 10px rgba(0,245,255,0.4)',
          }}
        >
          Vertex Premium Launches Sept–Oct 2026
        </p>
      </div>

      <div className="flex flex-col md:flex-row md:items-start gap-6 md:gap-8">
        {/* Left copy */}
        <div className="md:w-72 shrink-0">
          <p style={{ fontSize: '14px', color: '#a0b0d8', lineHeight: 1.7, marginBottom: '16px' }}>
            Get priority booking and launch-day pricing by signing up now.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-1 gap-2 md:gap-3">
            {[
              { icon: '◆', text: 'Priority booking access' },
              { icon: '◆', text: 'Exclusive launch pricing' },
              { icon: '◆', text: 'Updates as we get closer' },
            ].map((item) => (
              <div
                key={item.text}
                className="flex items-center gap-3"
                style={{
                  background: 'rgba(0,245,255,0.04)',
                  border: '1px solid rgba(0,245,255,0.1)',
                  padding: '10px 12px',
                }}
              >
                <span style={{ color: '#00f5ff', fontSize: '10px', flexShrink: 0 }}>{item.icon}</span>
                <p style={{ fontSize: '13px', color: '#a0b0d8', fontWeight: 500 }}>{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Tally Embed */}
        <div className="flex-1 min-w-0">
          <iframe
            data-tally-src="https://tally.so/embed/D4OkVN?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
            loading="lazy"
            width="100%"
            height="687"
            frameBorder={0}
            marginHeight={0}
            marginWidth={0}
            title="Waitlist"
            style={{ display: 'block', colorScheme: 'dark' }}
          />
        </div>
      </div>
    </section>
  );
}
